import * as React from 'react';
import {
    AdminUI,
    Resource, Loading, CustomRoutes,
    useAuthProvider, useStore, 
} from 'react-admin';
import { Route } from "react-router-dom";
import { useState } from 'react';
import about from '../about';
import users from '../users';
import jobs from '../jobs';
import jobsPublic from '../jobsPublic';
import workers from '../workers';
import Redirect from '../Redirect'
import MyLayout from './MyLayout';
import MyLoginPage from './MyLoginPage';

const customRoutes = (
    <CustomRoutes>
        <Route path="/redirect" element={<Redirect />} />
    </CustomRoutes>
)

/* eslint-disable react/jsx-key */
const knownResources = {
    about: <Resource name="about" {...about} />,
    users: <Resource name="users" {...users} />,
    usersOnlyEdit: <Resource name="users" edit={users.edit}/>,
    jobs: <Resource name="jobs" {...jobs} />,
    jobsPublic: <Resource name="public/jobs" options={{ label: 'Public/Jobs' }} {...jobsPublic} />,
    workers: <Resource name="workers" {...workers} />,
};
/* eslint-enable react/jsx-key */

const roleResourceKeys = {
    any: ["about", "jobsPublic"],
    user: ["usersOnlyEdit", "jobs"],
    admin: ["users", "jobs", "workers"],
}

const AsyncResources = () => {
    const authProvider = useAuthProvider();
    // Hook user change
    useStore('my.redirect.count');
    const [role, setRole] = useState(null)
    authProvider.getPermissions().then(r => setRole(r))
    // console.log(`role: ${role}`)
    const allowedResourceKeys = [...roleResourceKeys.any]
    if (Object.keys(roleResourceKeys).includes(role)) {
        allowedResourceKeys.push(...roleResourceKeys[role])
    }
    const allowedResourceEntries = allowedResourceKeys.map(
        key => {
            let entry = Object.entries(knownResources).find(([resourceKey, ]) => resourceKey === key);
            if (entry) {
                return entry;
            } else {
                console.warn(`AsyncResources: resource ${key} not found`)
                return null;
            }
        }
    ).filter(
        resource => resource !== null
    )

    return (
        <AdminUI ready={Loading} layout={MyLayout} title="DeepBlock" loginPage={MyLoginPage} disableTelemetry>
            {allowedResourceEntries.map(([resourceKey, resource]) => (
                <Resource key={resourceKey} {...resource.props} />
            ))}
            {customRoutes}
        </AdminUI>
    )
}

export default AsyncResources;
